import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import UsersActions from "../modules/UsersActions/UsersActionsPage";

export function UsersActionsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "users-actions-page-title",
    defaultMessage: "Users actions"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <UsersActions/>;
}
